import React, { useState, useEffect } from "react";
import "./SapFieldglassContent.css";
import Floaticons from "../Floaticons";
import FieldglassLearningJourney from "./FieldglassLearningJourney";
import SapFieldglassCards from "./SapFieldglassCards";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import mailData from ".././../data/mailData";
import {apiURL} from "../../Constant"

const SapFieldglassContent = () => {
  const { instance } = useMsal();
  const [username, setuserName] = useState(null);
  const [isUserPresent, setuserPresent] = useState(true);

  let program = "FI, S4Hana";
  const activeAccount = instance.getActiveAccount();
  //  const checkUserPresent = (name) => {
  //   axios
  //    .get(`${apiURL}/checkNominationList/${name}/${program}`, {
  //     headers: {
  //      "Cache-Control": "no-cache",
  //      Accept: "application/json",
  //      Pragma: "no-cache",
  //      Expires: "0",
  //     },
  //    })
  //    .then((res) => {
  //     console.log("Reponse is", res.data);
  //     let users = res.data;
  //     axios
  //      .get(`${apiURL}/checkAdminList/${name}`, {
  //       headers: {
  //        "Cache-Control": "no-cache",
  //        Accept: "application/json",
  //        Pragma: "no-cache",
  //        Expires: "0",
  //       },
  //      })
  //      .then((res) => {
  //       console.log("Reponse is", res.data);

  //       users.length != 0 || res.data.length != 0
  //        ? setuserPresent(true)
  //        : setuserPresent(false);
  //      })
  //      .catch((err) => {
  //       console.log(err);
  //      });
  //    })
  //    .catch((err) => {
  //     console.log(err);
  //    });
  //  };
  const checkUserPresent = (name) => {
    axios
      .get(`${apiURL}/checkUserActive/${name}`, {
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let activeUser = res.data;
        if (activeUser.length != 0) {
          axios
            .get(`${apiURL}/checkNominationList/${name}/${program}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              let users = res.data;
              users.length != 0 ? setuserPresent(true) : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          axios
            .get(`${apiURL}/checkAdminList/${name}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              console.log("Reponse is", res.data);

              res.data.length != 0
                ? setuserPresent(true)
                : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (activeAccount) {
      setuserName(activeAccount.idTokenClaims.enterpriseID);

      checkUserPresent(activeAccount.idTokenClaims.enterpriseID);
    } else {
      setuserName(null);
    }
  }, [activeAccount.idTokenClaims.enterpriseID]);
  return (
    <>
      <div id="SapFieldglassContent">
        <div className="main-banner">
          <img
            src="images/SapFieldglass/SAP-Fieldglass-banner.png"
            alt="Banner"
            className="banner-img"
          />
          <img
            src="images/Home/banner-strip.png"
            alt="strip"
            className="strip-img"
          />
          <div className="announcemnt-box">
            <p>
              <img
                src="images/Home/speaker.png"
                alt="speaker"
                className="speaker-img"
              />
              <marquee
                width="92%"
                direction="left"
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                {" "}
                <b>Come Join Us</b> on an exhilarating learning Journey on ABC
                University Platform!!!
              </marquee>
            </p>
          </div>
          <Floaticons />
        </div>
        {isUserPresent ? (
          <div className="main-container">
            {/* section 1  */}
            <div className="about-container">
              <div className="about-wrap">
                <h2>About SAP Fieldglass</h2>
                <p>
                  SAP Fieldglass is a cutting-edge cloud-based Vendor Management
                  System (VMS) that revolutionizes the way organizations manage
                  their contingent workforce. With its robust suite of features
                  and capabilities, SAP Fieldglass enables companies to
                  efficiently and effectively oversee their external workforce,
                  including contractors, freelancers, and temporary staff.
                </p>
              </div>
            </div>
            {/* section 2  */}
            <div id="SapFI-Objective">
              <div className="program-container">
                <div className="program-wrap">
                  <h2>Program Objectives</h2>
                  <ul>
                    <li>
                      Understand the concept of Vendor Management System (VMS)
                      and its significance in modern workforce management.
                    </li>
                    <li>
                      Explore the key features and functionalities of SAP
                      Fieldglass and how they contribute to effective contingent
                      workforce management.
                    </li>
                    <li>
                      Learn how to navigate and utilize the SAP Fieldglass
                      platform for vendor management, including supplier
                      collaboration, contract management, and performance
                      tracking.
                    </li>
                    <li>
                      Learn about the latest trends and innovations in the field
                      of contingent workforce management, and how SAP Fieldglass
                      continues to evolve to meet the changing needs of
                      organizations
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <FieldglassLearningJourney />
            {/* <div className="external-certification-container">
       <h5>External Certifications</h5>
       <p>
        Complete your learning journey and earn accredited external certification in the
        area of your expertise which can help in advancing your career.
       </p>
       <div className="ex-wrapper">
        <div>
         <img src="images/Home/Journey-icon.png" alt="certification-icon" />
         <span>Lorem ipsum dolor sit amet.</span>
        </div>
        <div>
         <img src="images/Home/Journey-icon.png" alt="certification-icon" />
         <span>Lorem ipsum dolor sit amet.</span>
        </div>
       </div>
      </div> */}
            <SapFieldglassCards />
            {/* section 4  */}
            <div className="features-container SRE">
              <h5>Program Highlights</h5>
              <div className="features-wrap">
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon1.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Self-paced Learning</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon2.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>SME Connects</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon3.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Final Assessment</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon4.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Earn Completion Certificates, Flair, R&R</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon6.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>End-to-End case studies</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="alter-conatiner">
            <p>
              You are not enrolled to this learning program. Please contact
              &nbsp;
              <a
                onClick={() => {
                  window.open(`mailto:${mailData.LKM_ABCUniversity_mail}`);
                }}
                href=""
              >
                {mailData.LKM_ABCUniversity_mail}
              </a>
              &nbsp; for any queries regarding the program.
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default SapFieldglassContent;
